import { z } from "zod"
import { CURRENCIES } from "./currency"

export const emptyAsNull = <T extends z.ZodTypeAny>(schema: T) =>
  schema.nullable().transform((v) => (v === "" ? null : v))

export const decimalString = emptyAsNull(
  z
    .string()
    .refine((v) => v === "" || !Number.isNaN(Number(v)), "Must be a number"),
)

export const currency = z.enum(CURRENCIES)

export const optionalEmail = z
  .string()
  .trim()
  .refine(
    (value) => value === "" || z.string().email().safeParse(value).success,
    "Enter a valid email",
  )
